import {observer} from 'mobx-react';
import React from 'react';

import {Button} from '@udemy/react-core-components';
import {FooterButtons} from '@udemy/react-dialog-components';
import {AlertBanner} from '@udemy/react-messaging-components';

import {CreateModalStore} from 'src/stores/create-modal-store';

import {ScopeSelection} from '../scope-selection.react-component';

export const ScopeSelectionStep = observer(({store}: {store: CreateModalStore}) => {
    return (
        <>
            <h3 className="ud-heading-md">Select scopes</h3>
            <p>
                Scopes define the access for the personal tokens. Read more about OAuth scopes in
                the{' '}
                <a href="https://business-support.udemy.com/hc/en-us/articles/115005587568-Getting-Help">
                    Authorization Guide
                </a>
            </p>

            <ScopeSelection createModalStore={store} />

            <AlertBanner
                title="When Creating API Keys, Use Minimal Viable Scopes"
                udStyle="warning"
                showCta={false}
                body={
                    'These scopes indicate the endpoints accessible to access_tokens created with ' +
                    'the API key. As a general data security principle, we highly recommend that ' +
                    'you make your API keys with a minimal number of scopes to enable your ' +
                    'integration work to succeed.'
                }
            ></AlertBanner>

            <FooterButtons>
                <Button udStyle="ghost" onClick={() => store.close()}>
                    Cancel
                </Button>

                <Button disabled={store.form.isSubmitting} onClick={() => store.save()}>
                    Create API Client
                </Button>
            </FooterButtons>
        </>
    );
});
